/* Rovera Product Page - Gallery + Variant Picker */
(function () {
  'use strict';

  var data = window.__rvrProduct;
  if (!data) return;

  var variants = data.variants;
  var selected = {};

  var initVariant = variants.find(function (v) { return v.id === data.currentVariantId; });
  if (initVariant) {
    initVariant.options.forEach(function (val, i) { selected[i] = val; });
  }

  var slides = [].slice.call(document.querySelectorAll('.rvr-slide'));
  var thumbs = [].slice.call(document.querySelectorAll('.rvr-thumb'));

  function switchMedia(mediaId) {
    var id = String(mediaId);
    slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.mediaId === id); });
    thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.mediaId === id); });
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { switchMedia(t.dataset.mediaId); });
  });

  function formatMoney(cents) {
    return String.fromCharCode(163) + (cents / 100).toFixed(2);
  }

  function findVariant() {
    return variants.find(function (v) {
      return Object.keys(selected).every(function (i) {
        return v.options[parseInt(i, 10)] === selected[i];
      });
    });
  }

  function applyVariant(v) {
    var sel = document.getElementById('RvrVariantId');
    if (sel) sel.value = v.id;

    var priceEl = document.getElementById('rvrPrice');
    if (priceEl) priceEl.textContent = formatMoney(v.price);

    var atcBtn = document.getElementById('RvrAddToCart');
    var atcPriceEl = document.getElementById('RvrAtcPrice');
    if (atcBtn) {
      if (v.available) {
        atcBtn.removeAttribute('aria-disabled');
        if (atcPriceEl) atcPriceEl.textContent = formatMoney(v.price);
      } else {
        atcBtn.setAttribute('aria-disabled', 'true');
        atcBtn.textContent = 'Sold Out';
      }
    }

    if (v.featured_media && v.featured_media.id) {
      switchMedia(v.featured_media.id);
    }
  }

  var optBtns = [].slice.call(document.querySelectorAll('.rvr-swatch, .rvr-size-btn'));
  optBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var optIdx = parseInt(btn.dataset.optionIndex, 10);
      var val = btn.dataset.value;

      var group = btn.closest('.rvr-option');
      if (group) {
        [].slice.call(group.querySelectorAll('.rvr-swatch, .rvr-size-btn'))
          .forEach(function (b) { b.classList.remove('is-active'); });
      }
      btn.classList.add('is-active');

      var labelEl = document.getElementById('rvrOptVal' + optIdx);
      if (labelEl) labelEl.textContent = val;

      selected[optIdx] = val;
      var match = findVariant();
      if (match) applyVariant(match);
    });
  });

})();
